export { FocusLock } from "./focus-lock"
export type { FocusLockProps } from "./focus-lock"
